<template>
    <div>
        <div v-if="! showRecieptPage">
            <!-- <hr class="my-4">  -->
            <h2
                class="mb-0 text-uppercase text-center"
            >
                Add Payment to Transaction with number <br>
                <small class="text-danger">
                    {{ orderNumber }}
                </small>
            </h2>
            <hr class="my-4">

            <h3
                class="mb-0 text-uppercase text-center"
            >
                Required Amount :
                <b class="text-danger">
                    {{ totalAmount | formatPrice }}
                </b>
            </h3>

            <hr class="my-4">

            <div v-if="! hideVerifyRRR">
                <h4 class="mb-0 text-danger">
                    Note: Read Carefully<br>
                    <ul>
                        <li>
                            <b class="text-primary">Generating RRR</b> - You can now generate RRR (Remita Retrieval
                            Reference) number and move to make payment offline through the designated banks. After
                            successful payment at the bank, you are advised to wait for 24 hours. Afterwards, you can now
                            proceed to add your payment to the portal. If you want to generate RRR for payment through designated
                            banks, kindly click on <strong class="text-primary">Generate RRR</strong> button.
                        </li><br>
                        <li>
                            <b class="text-primary">Adding Payment via RRR</b> - If you want to add payment to your
                            application via RRR, the RRR number must be a valid one (i.e. it must have to be paid and
                            not used before on the portal). Kindly click on
                            <strong class="text-primary">Add RRR</strong> button.
                        </li>
                    </ul>
                </h4>

                <hr class="my-4">
            </div>

            <div class="text-center" v-if="! hideVerifyRRR">
                <base-button
                    type="primary" size="lg"
                    @click="generateRRR()"
                >
                    <i class="fa fa-cogs"></i>
                    {{ isloading ? 'Please Wait' : 'Generate RRR' }}
                </base-button>

                <base-button
                    type="success" size="lg"
                    @click="showVerifyPage()"
                    :disabled="isloading"
                >
                    <i class="fa fa-credit-card"></i>
                    Add RRR
                </base-button>

                <base-button
                    type="danger" size="lg"
                    @click="removeAddPayment"
                >
                    <i class="fa fa-times"></i>
                    Cancel
                </base-button>
            </div>

            <div v-if="hideVerifyRRR">
                <h4 class="mb-0 text-danger">
                    Note: Kindly add all RRR payments that weren't generated from MDCN portal (i.e. RRR generated
                    from Remita Platform) on or before <em class="text-primary">31st August, 2020</em>. However,
                    RRR can now be generated from the portal and it is now only the valid means to generate payment
                    for MDCN portal, else any other means will not be accepted and will be forfeited
                </h4>

                <hr class="my-4">

                <div class="row">
                    <div class="col-md-3 text-center"></div>
                    <div class="col-md-6 text-center" v-if="! showPaymentBlade">
                        <base-input alternative=""
                            label="Valid RRR Number"
                            placeholder="Enter Valid RRR Number"
                            input-classes="form-control-alternative"
                            type="number"
                            v-model="rrr"
                        />
                    </div>
                    <div class="col-md-3 text-center"></div>
                </div>


                <div class="text-center" v-if="! showPaymentBlade">

                    <base-button
                        type="success" size="lg"
                        @click="verifyPayment()"
                    >
                        <i class="fa fa-history"></i>
                        {{ isloading ? 'Please Wait' : 'Verify RRR' }}
                    </base-button>

                    <base-button
                        type="danger" size="lg"
                        @click="removeAddPayment"
                    >
                        <i class="fa fa-times"></i>
                        Cancel
                    </base-button>
                </div>

                <div v-if="showPaymentBlade">
                    <h2 class="text-center">
                        Payment Details
                    </h2>

                    <hr class="my-4">

                    <h3 class="text-center">
                        Application Type: &nbsp;
                        <em class="text-capitalize font-weight-light">
                            {{ this.application.name }}
                        </em>
                    </h3>
                    <h3 class="text-center">
                        Amount: &nbsp;
                        <em class="text-capitalize font-weight-light">
                            {{ paymentDetails.amount | formatPrice }}
                        </em>
                    </h3>
                    <h3 class="text-center">
                        Transaction Number: &nbsp;
                        <em class="text-capitalize font-weight-light">
                            {{ orderNumber }}
                        </em>
                    </h3>
                    <h3 class="text-center">
                        RRR Number: &nbsp;
                        <em class="text-capitalize font-weight-light">
                            {{ paymentDetails.RRR }}
                        </em>
                    </h3>
                    <h3 class="text-center">
                        Payment Date: &nbsp;
                        <em class="font-weight-light">
                            {{ paymentDetails.paymentDate | getDateTimeFormat }}
                        </em>
                    </h3>

                    <hr class="my-4">

                    <div class="text-center">
                        <base-button
                            type="success" size="lg"
                            @click="updatePayment()"
                        >
                            <i class="fa fa-credit-card"></i>
                            {{ isloading ? 'Please Wait' : 'Add Payment' }}
                        </base-button>
                        <base-button
                            type="danger" size="lg"
                            @click="removeAddPayment"
                        >
                            <i class="fa fa-times"></i>
                            Cancel
                        </base-button>
                    </div>
                </div>
            </div>
        </div>

        <!-- generate RRR details template here -->
        <GenerateRrr
            :cpd="cpd"
            :rrr="rrr"
            :app="application"
            :amount="totalAmount"
            :orderId="orderNumber"
            v-on:removeAddPayment="removeAddPayment"
            v-if="showRecieptPage"
        />
    </div>

</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import moment from 'moment';
    import GenerateRrr from './GenerateRrr.vue';
    import swal from 'sweetalert2';// import sweet alert
    import axios from 'axios';

    export default {
        name: 'AddPayment',
        props: ["orderNumber", "application", "loadApplication", "serviceType", "app_id", "removeAddPayment", 
                "totalAmount", "showCompletedPage"],
        components: {
            GenerateRrr
        },
        data() {
            return {
                rrr: null,
                isloading: false,
                showPaymentBlade: false,
                paymentDetails: {},
                hideVerifyRRR: false,
                showRecieptPage: false
            }
        },
        filters: {
            getDateTimeFormat(value) {
                if(value) {
                    return moment(value).format('Do MMM, YYYY [at] h:mm:ss a');
                } else {
                    return 'N/A';
                }
            },
            formatPrice(value) {
                if(value) {
                    let val = (value/1).toFixed(2).replace(',', '.');
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+ ' NGN';
                } else {
                    return 'N/A';
                }
            }
        },
        computed: {
            ...mapGetters(['cpd'])
        },
        methods: {
            ...mapActions(['getRemitaPaymentStatus', 'updateApplicationTransaction', 'generateVerificationRrr',
                'fetchCpdProfile']),
            generateRRR() {// generate rrr
                let data = {
                    serviceTypeCode : this.serviceType.remita_code,
                    amount : this.totalAmount,
                    orderId : this.orderNumber,
                    payerName : this.cpd.name,
                    payerEmail : this.cpd.email,
                    payerPhone : this.cpd.phone
                };
                this.isloading = true;
                this.rrr = null
                this.preloader();
                this.generateVerificationRrr(data).then((res) => {
                    this.isloading = false;
                    swal.close();
                    if(res.statuscode == "025") {
                        this.rrr = res;
                        this.showRecieptPage = true;
                    } else {
                        let msg = "RRR was not generated, try again...";
                        swal.fire("RRR Failed!", msg, "warning");
                    }
                }).
                catch(() => {
                    this.isloading = false;
                    let msg = "Network Failure!, kindly reload the page...";
                    swal.fire("Error Ocurred!", msg, "warning");
                });
            },
            showVerifyPage() {
                return this.hideVerifyRRR = ! this.hideVerifyRRR;
            },
            verifyPayment() {
                this.preloader();// show loading
                this.isloading = true;
                let status = this.verifyRrrNumber();
                // console.log(status); 160352882748    250332191070  330204213948
                if(status) {
                    let data = { rrr : this.rrr, is_url : true };
                    this.getRemitaPaymentStatus(data).then((res) => {// create
                        if(res.status) {// update transaction
                            this.verifyThroughRemita(res.url);
                        } else {
                            swal.fire('Payment Failed!', res.msg, 'warning');
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        let message = 'An error while verying payment, kindly reload and try again';
                        swal.fire('Network Failure!', message, 'warning');
                    });
                }
            },
            verifyThroughRemita(url) {
                axios.get(url).then((res) => {
                    this.isloading = false;
                    if(res.status == 200 && res.data) {
                        let check = res.data;
                        if((check.status == '00') || (check.status == '01')) {
                            this.paymentDetails = res.data;
                            this.showPaymentBlade = true;
                            swal.close();
                        } else {
                            let msg = 'Payment was not successful, kindly enter a valid RRR';
                            swal.fire('Payment Failed!', msg, 'warning');
                        }                        
                    }
                })
                .catch(() => {//check for failure
                    this.isloading = false;
                    let msg = 'Payment was not verified, kindly try again';
                    swal.fire('Payment Verfication Failed!', msg, 'warning');
                });
            },
            verifyRrrNumber() {
                if(this.rrr && this.rrr.length > 10) {
                    return true;
                } else if(this.rrr && this.rrr.length < 10) {
                    swal.fire("Incomplete RRR!", "Kindly check and enter a valid RRR", "warning");
                    return false;
                } else {
                    swal.fire("No RRR!", "Kindly enter a valid RRR, and try again", "warning");
                    return false;
                }
            },
            updatePayment() {// update transaction
                this.isloading = true;
                let data = this.paymentDetails;
                data.orderId = this.orderNumber;// add trans no
                data.id = this.application && this.application.id ? this.application.id : false;
                if((this.totalAmount <= data.amount) && data.id) {// add payment
                    this.preloader();// show loading
                    this.updateApplicationTransaction(data).then((res) => {// create
                        this.isloading = false;
                        if(res.status) {// update transaction
                            swal.fire('Payment Added!', res.msg, 'success');
                            this.showCompletedPage();// remove
                        } else {
                            swal.fire('Payment Failed!', res.msg, 'warning');
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        let message = 'An error while adding payment, kindly reload and try again';
                        swal.fire('Network Failure!', message, 'warning');
                    });
                } else {
                    this.isloading = false;
                    let message = 'Amount on the RRR is less than the required amount';
                    swal.fire('Invalid Amount!', message, 'warning');
                }
            },
            isNotEmpty(obj) {// check for empty field
                return ! Object.keys(obj).some(k => !obj[k]);
            },
            showAlert(msg, type) {
                this.$notify({
                    type: type,
                    title: msg
                })
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {
            this.fetchCpdProfile();
        }
    }
</script>

<style scoped>
.right {
    float: right;
}
</style>